import { VOICE_RECORDING_INFO_TYPE } from '../model/constants'
import { VoiceRecordingInfoPayload } from '../model/types'

export const isVoiceRecordingInfo = (params: unknown): params is VoiceRecordingInfoPayload => {
  if (!params || typeof params !== 'object') return false

  const payload = params as Partial<VoiceRecordingInfoPayload>
  return payload.type === VOICE_RECORDING_INFO_TYPE
    && (payload.state === 'start' || payload.state === 'stop')
}
